module.exports = __webpack_public_path__ + "img/linkedin-white.2f7dd007.svg";